// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import type { PaymentRecordTrackingDetailsItem } from 'types/transaction'

interface TrackingDetailsFieldsProps {
  trackingDetails: PaymentRecordTrackingDetailsItem[]
}

const TRACKING_FIELDS = [
  { key: 'imad', id: 'imad', testId: 'imad', labelKey: 'transactions.sideBar.imad' },
  { key: 'omad', id: 'omad', testId: 'omad', labelKey: 'transactions.sideBar.omad' },
  {
    key: 'traceId',
    id: 'trace-id',
    testId: 'trace-id',
    labelKey: 'transactions.sideBar.traceId',
  },
  { key: 'uetr', id: 'uetr', testId: 'uetr', labelKey: 'transactions.sideBar.uetr' },
] as const

const TrackingDetailsFields = ({ trackingDetails }: TrackingDetailsFieldsProps) => {
  const { t } = useTranslation()
  const tracking = trackingDetails?.[0]
  if (!tracking) return null

  const matchedFields = TRACKING_FIELDS.filter(({ key }) => tracking[key])
  if (!matchedFields.length) return null

  return (
    <>
      {matchedFields.map(({ key, id, testId, labelKey }) => (
        <DataListItem
          key={key}
          id={id}
          testId={testId}
          title={t(labelKey)}
          body={ellipseMiddleText(tracking[key], 20, 10)}
          copyText={tracking[key]}
        />
      ))}
    </>
  )
}

export default TrackingDetailsFields
